interface VideoFormat {
  type: string
  extension: string
}

export const VIDEO_FORMATS: VideoFormat[] = [
  { type: 'video/mp4', extension: 'mp4' },
  { type: 'video/webm', extension: 'webm' },
]

export const DEFAULT_VIDEO_POSTER_FORMAT = 'webp'
